import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';

export default function JustOnePageOverflowMenu({
  items = [],
  className = '',
  buttonClassName = '',
  align = 'right',
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  if (!items.length) return null;

  const visible = items.filter((it) => !it.hidden);

  return (
    <div ref={rootRef} className={`relative ${className}`}>
      <button
        type="button"
        className={`p-2 rounded-lg hover:bg-muted transition-smooth ${buttonClassName}`}
        aria-expanded={open}
        aria-label="Menu"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <Icon name="MoreVertical" size={18} />
      </button>
      {open ? (
        <div
          className={`absolute z-50 mt-1 min-w-[200px] rounded-lg border border-border bg-card shadow-elevation-3 py-1 ${
            align === 'left' ? 'left-0' : 'right-0'
          }`}
        >
          {visible.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2 ${
                item.destructive ? 'text-destructive' : 'text-foreground'
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                item.onClick?.();
              }}
            >
              {item.icon ? <Icon name={item.icon} size={15} /> : null}
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
